module.exports = __webpack_public_path__ + "static/media/free-damm-limon.52f6a29f.jpg";